import { useId } from "react";

import { DiagramFrame } from "@/app/features/diagrams/components/shared/DiagramFrame";
import { DiagramMarkers } from "@/app/features/diagrams/components/shared/DiagramMarkers";
import { DiagramNode } from "@/app/features/diagrams/components/shared/DiagramNode";

import "@/app/features/diagrams/functions/s1000d/dmcTopologySpec";

export function DmcFacetedDecompositionVisual() {
  const titleId = useId();
  const descId = useId();

  return (
    <DiagramFrame
      width={700}
      height={450}
      title="S1000D DMC Faceted Decomposition Architecture"
      description="Architectural diagram illustrating how a structured S1000D Data Module Code (DMC) decomposes into three distinct query channels: Physical System Breakdown, Maintenance Action Intent, and Operational Context, feeding a unified query engine."
      titleId={titleId}
      descId={descId}
      viewBox="0 0 700 450"
      frame={{
        kind: "boundary",
        label: "DMC COORDINATE DECOMPOSITION & FACETING",
        x: 18,
        y: 18,
        width: 664,
        height: 414,
      }}
    >
      <DiagramMarkers prefix="dmc-" />

      {/* RAW DMC STRING */}
      <DiagramNode
        x={150}
        y={42}
        width={400}
        height={48}
        eyebrow="RAW S1000D COORDINATE"
        label="DMC-S1000D-F-04-10-0301-00A-022A-D"
        variant="capsule"
      />

      <path
        d="M 350 90 L 350 116"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        opacity="0.45"
        markerEnd="url(#dmc-arrow-neutral)"
      />

      {/* PARSER / TOKENIZER */}
      <DiagramNode
        x={210}
        y={118}
        width={280}
        height={46}
        label="Coordinate Tokenizer"
        sublabel="Segment Grammar & Field Normalizer"
        variant="standard"
      />

      {/* FAN-OUT BRANCHING PATHS */}
      <path
        d="M 350 164 L 350 185 M 350 185 L 135 185 L 135 208"
        fill="none"
        stroke="var(--ga-diagram-keyword)"
        strokeWidth="1.5"
        markerEnd="url(#dmc-arrow-neutral)"
      />
      <path
        d="M 350 185 L 350 208"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        opacity="0.6"
        markerEnd="url(#dmc-arrow-neutral)"
      />
      <path
        d="M 350 185 L 565 185 L 565 208"
        fill="none"
        stroke="var(--ga-diagram-agent, #2563eb)"
        strokeWidth="1.5"
        strokeDasharray="4 3"
        markerEnd="url(#dmc-arrow-blue)"
      />

      {/* BRANCH 1: SYSTEM HIERARCHY */}
      <DiagramNode
        x={40}
        y={210}
        width={190}
        height={76}
        eyebrow="PHYSICAL BREAKDOWN"
        label="SNS Hierarchy"
        sublabel="04-10-0301 Air Conditioning"
        variant="brass"
      />

      {/* BRANCH 2: MAINTENANCE ACTION */}
      <DiagramNode
        x={255}
        y={210}
        width={190}
        height={76}
        eyebrow="MAINTENANCE INTENT"
        label="Information Code"
        sublabel="022A Description of Operation"
        variant="standard"
      />

      {/* BRANCH 3: OPERATIONAL CONTEXT */}
      <DiagramNode
        x={470}
        y={210}
        width={190}
        height={76}
        eyebrow="OPERATIONAL CONTEXT"
        label="Location & Applicability"
        sublabel="Location D · Flight-Line Tier"
        variant="standard"
      />

      {/* CONVERGENCE TO MERGE */}
      <path
        d="M 135 286 L 135 318 L 350 318"
        fill="none"
        stroke="var(--ga-diagram-keyword)"
        strokeWidth="1.5"
      />
      <path
        d="M 350 286 L 350 318"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        opacity="0.6"
      />
      <path
        d="M 565 286 L 565 318 L 350 318"
        fill="none"
        stroke="var(--ga-diagram-agent, #2563eb)"
        strokeWidth="1.5"
        strokeDasharray="4 3"
      />

      <path
        d="M 350 318 L 350 348"
        fill="none"
        stroke="var(--ga-diagram-success, #15803d)"
        strokeWidth="1.8"
        markerEnd="url(#dmc-arrow-green)"
      />

      {/* FINAL UNIFIED QUERY & FACET ENGINE */}
      <DiagramNode
        x={140}
        y={350}
        width={420}
        height={58}
        eyebrow="SEARCH & DELIVERY PLATFORM"
        label="DMC-Aware Faceted Query Engine"
        sublabel="Zero-Cost Multi-Axis Navigation & Instant Lookup"
        variant="success"
      />
    </DiagramFrame>
  );
}
